<template>
    <label
      class="flex flex-col items-center justify-center w-full h-1/3 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
    >
        <div class="flex flex-col items-center justify-center pt-2 pb-1 mx-3">
            <svg
            aria-hidden="true"
            class="w-5 h-5 mb-1 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
            ></path>
            </svg>
            <p class="text-sm text-gray-500 dark:text-gray-400 font-semibold">
                Click to upload
            </p>
        </div>
      <slot></slot>
    </label>
  </template>
  
  <script>
  export default {
    
  };
  </script>
  
  <style scoped>
  </style>